import React, { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TooltipContainer, TooltipTrigger, TooltipContent } from './styles';

interface TooltipProps {
	content: string;
}

export function Tooltip({ content }: Readonly<TooltipProps>) {
	const [isVisible, setIsVisible] = useState(false);

	const handleMouseEnter = () => {
		setIsVisible(true);
	};

	const handleMouseLeave = () => {
		setIsVisible(false);
	};

	return (
		<TooltipContainer>
			<TooltipTrigger onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				<InfoCircleOutlined style={{ fontSize: '15px' }} />
			</TooltipTrigger>

			{isVisible && <TooltipContent>{content}</TooltipContent>}
		</TooltipContainer>
	);
}
